window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
import 'axios';

export default {
    subscribe() {
        var email = document.getElementById('subscriber-email').value;
        var name = document.getElementById('subscriber-name').value;

        if (email == "" || name === "") {
            return {
                message: "Vă rugăm să scrieti un e-mail și un nume pentru a vă abona",
                color: 'red'
            };
        }

        axios.post('/api/subscribe', {
            email: email,
            name: name,
            locale: window.locale
        }).then((response) => {
            return {
                message: response.data.message,
                color: 'green'
            };
        }).catch((error) => {
            if (error.response) {
                return {
                    message: error.response.data.message,
                    color: 'red'
                };
            } else {
                return {
                    message: "Eroare la trimiterea cererii de abonare",
                    color: 'red'
                };
            }
        });
    }
}